import React from 'react';
import classnames from 'classnames';
import { User, RootState } from 'v2/models';
import { useSelector } from 'react-redux';
import MemberActions from './MemberActions/MemberActions';

interface ActiveMembersListProps {
  members: User[];
}

const BuyerMembersList = ({ members }: ActiveMembersListProps) => {
  const user = useSelector((state: RootState) => state.user.user);

  return (
    <>
      <table className="table table-gray-light" aria-label="Team members list">
        <thead>
          <tr>
            <th>Name</th>
            <th>Email address</th>
            <th>Licenses</th>

            <th></th>
          </tr>
        </thead>
        <tbody data-cy="team-members-table-list">
          {members.map((member) => {
            const isDisabled = !member.active || member.id === user.id;

            return (
              <tr key={member.id} data-cy="team-member-info-table-row">
                <td>
                  <p
                    aria-disabled={isDisabled}
                    data-cy="team-member-full-name-text"
                  >
                    {member.first_name} {member.last_name}
                  </p>
                </td>
                <td>
                  <p
                    aria-disabled={isDisabled}
                    data-cy="team-member-email-text"
                  >
                    {member.email}
                  </p>
                </td>
                <td>
                  <p
                    aria-disabled={isDisabled}
                    className={classnames('text-capitalize')}
                    data-cy="team-member-licenses-text"
                  >
                    {member.plans
                      .map((plan) => plan.replaceAll('-', ' '))
                      .join(', ')}
                  </p>
                </td>

                <td>
                  {member.id !== user.id ? (
                    <MemberActions isDisabled={isDisabled} member={member} />
                  ) : null}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </>
  );
};

export default BuyerMembersList;
